module.exports = __webpack_public_path__ + "img/logo_inmatic.6816042c.png";